const config = Object.freeze({
  api: {
    baseUrl: process.env.REACT_APP_API_URL
  },
  msal: {
    auth: {
      clientId: '99acebc4-bb8f-4d67-8b72-54cdb8740b48'
    },
    cache: {
      cacheLocation: 'sessionStorage'
    }
  },
  outlook: {
    readRetryCount: 30,
    readRetryTimeout: 2000
  },
  autoLoginTimeout: 300,
  errorTimeout: 7000,
  waitForSaveTimeout: 5000
})

export default config
